import Divider from "@mui/material/Divider";

import { SubSectionContainer } from "@app/analytics/TopicReport/styles";

import { Column } from "@rui/Stack";

import LatestUpdate from "./LatestUpdate";
import { Card } from "./styles";
import Takeaways from "./Takeaways";
import TopicReportSummary from "./TopicReportSummary";

const TopicReportNotes = () => {
  return (
    <SubSectionContainer>
      <Column spacing={2}>
        <LatestUpdate />
        <Card spacing={2}>
          <TopicReportSummary />
          <Divider />
          <Takeaways />
        </Card>
      </Column>
    </SubSectionContainer>
  );
};

export default TopicReportNotes;
